<template>
    <div class="my-4">
        <UInput v-model="q" placeholder="Filter connectors..." icon="heroicons:magnifying-glass-20-solid" />
        <UTable :rows="filteredRows" :columns="columns" class="mt-4">
            <template #Icon-data="{ row }">
                <img :src="row.Icon" alt="" class="w-10 h-10" />
            </template>
            <template #Source-data="{ row }">
                <a :href="row.Source" target="_blank" class="text-primary-500 underline">Source
                    <Icon name="heroicons:arrow-up-right-16-solid" class="inline mr-1 align-top text-xs" />
                </a>
            </template>
            <template #Docs-data="{ row }">
                <a :href="row.Docs" target="_blank" class="text-primary-500 underline">Docs
                    <Icon name="heroicons:arrow-up-right-16-solid" class="inline mr-1 align-top text-xs" />
                </a>
            </template>
        </UTable>
    </div>
</template>


<script setup>
import connectors from '~/server/data/connectors_airbyte.json'
const sources = connectors[0]

const columns = [{
    key: "Connector Name",
    label: "Connector",
    sortable: true
},
// {
//     key: "Definition Id",
//     label: "Definition Id"
// }, 
{
    key: "Icon",
    label: "Icon"
},
{ key: "Source", label: "Source" },
{ key: "Docs", label: "Docs" }
]

const q = ref('')

const filteredRows = computed(() => {
    if (!q.value) {
        return sources
    }

    return sources.filter((source) => {
        return Object.values(source).some((value) => {
            return String(value).toLowerCase().includes(q.value.toLowerCase())
        })
    })
})
</script>
